import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { LogService } from './services/log.service';
import Bowser from 'bowser';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly logger: LogService = inject(LogService);
  readonly tempVersion: string = '1.1.17';

  title = 'Theradea';
  constructor() {
    console.log('env', {
      version: this.tempVersion,
      production: environment.production,
      projectId: environment.projectId,
    });
    this.logger.log('app-start', {
      version: this.tempVersion,
      url: location.href,
      production: environment.production,
      projectId: environment.projectId,
    });

    const browser = Bowser.getParser(window.navigator.userAgent);
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    const browserDetails = {
      browser: {
        name: browser.getBrowserName(),
        version: browser.getBrowserVersion(),
      },
      platform: {
        vendor: browser.getPlatform().vendor,
        model: browser.getPlatform().model,
        type: browser.getPlatformType(),
      },
      engine: {
        name: browser.getEngine(),
      },
      os: {
        name: browser.getOS().name,
        version: browser.getOS().version,
      },
      touch: isTouchDevice,
      cookiesEnabled: navigator.cookieEnabled,
      userAgent: window.navigator.userAgent,
    };
    this.logger.log(
      'plattform ' +
        browserDetails.platform.type +
        ' | ' +
        browserDetails.os.name +
        ' | ' +
        browserDetails.browser.name +
        ' ' +
        browserDetails.browser.version,
      browserDetails
    );
    if (environment.production) {
      console.log = () => {};
      // console.warn = () => {};
      // console.error = () => {};
    }
  }
}
